export default __webpack_public_path__ + "static/media/The_Dichotomy_Of_Fame_Featuring_Balesh_On_Shehnai,_Kabuli_On_Guitars.72f7827f.mp3";